export default __webpack_public_path__ + "static/media/icon_03_digital_marketing.5eabd70b.svg";